module.exports = __webpack_public_path__ + "img/2_280.775e8e1f.png";